import { requestFlatPeriod } from '../constants/requestFlat';
import { requestInPeriodColorMap } from '../constants/stagesColorMaps';

const useFlatIndicatorRequestCount = (requests = []) => {
  if (!requests || !requests?.length) return [];

  const countRequestMap = new Map([
    [
      'sumDeadline',
      {
        value: 'Заявки с подходящим сроком выполнения',
        color: requestInPeriodColorMap.get(requestFlatPeriod.rightTime),
        count: 0,
      },
    ],
    [
      'sumExpired',
      {
        value: 'Просроченные заявки',
        color: requestInPeriodColorMap.get(requestFlatPeriod.expired),
        count: 0,
      },
    ],
    [
      'sumExcess',
      {
        value: 'Превышения проверочной даты',
        color: requestInPeriodColorMap.get(requestFlatPeriod.excess),
        count: 0,
      },
    ],
  ]);

  requests.forEach((request) => {
    if (!!request.sumExcess) {
      countRequestMap.set('sumExcess', {
        ...countRequestMap.get('sumExcess'),
        count:
          countRequestMap.get('sumExcess').count + (request.sumExcess || 0),
      });
    }

    if (!!request.sumExpired) {
      countRequestMap.set('sumExpired', {
        ...countRequestMap.get('sumExpired'),
        count:
          countRequestMap.get('sumExpired').count + (request.sumExpired || 0),
      });
    }

    if (!!request.sumDeadline) {
      countRequestMap.set('sumDeadline', {
        ...countRequestMap.get('sumDeadline'),
        count:
          countRequestMap.get('sumDeadline').count + (request.sumDeadline || 0),
      });
    }
  });

  return Array.from(countRequestMap.values());
};

export default useFlatIndicatorRequestCount;
